import type { TFunction } from 'i18next';

import type { Profile } from '@src/entities/agent-contract';

import type { AgentUser } from '@entities/agent-user';

import { PULSE_SUPPORT_EMAIL } from '../constants';
import { getFullFio } from './get-full-fio';
import { getSupportMailHref } from './get-support-mail-href';

export interface SupportEmailDataValues {
  href: string;
  mailtoHref: string;
  subject: string;
  phone: string;
  fio?: string;
  lnr?: string;
  additionalLnr?: string;
  appeal?: string;
}

export interface SupportEmailDataParams {
  t: TFunction;
  username: string | null;
  profile?: Profile;
  agent?: AgentUser;
  appealPlace?: string;
}

// TODO: add hook for/from this function with `const tCommon = useCommonTranslation();`
export const getSupportMailDataValues = ({
  t,
  username,
  profile,
  agent,
  appealPlace,
}: SupportEmailDataParams): SupportEmailDataValues => {
  const { firstName = '', middleName = '', lastName = '' } = profile || {};
  const {
    lnrCode7778: additionalLnrCode,
    lnrCode719: lnrCode,
    phone: agentPhone,
  } = agent || {};
  const phoneNumber = agentPhone || username;
  const phone = phoneNumber ? t('COMMON:mailto.phone', { phoneNumber }) : '';
  const fullFio = getFullFio(lastName, firstName, middleName);
  const fio = !!fullFio ? t('COMMON:mailto.fio', { fullFio }) : '';
  const appeal = !!appealPlace
    ? t('COMMON:mailto.appeal', { appealPlace })
    : '';

  let lnr = '';
  let additionalLnr = '';
  const isContainsLnr = !!lnrCode || !!additionalLnrCode;

  if (isContainsLnr) {
    const isWithAdditionalLnr = !!lnrCode && !!additionalLnrCode;

    lnr = t('COMMON:mailto.lnr', {
      lnrCode: isWithAdditionalLnr ? lnrCode : additionalLnrCode,
    });
    additionalLnr = isWithAdditionalLnr
      ? t('COMMON:mailto.additionalLnr', { additionalLnrCode })
      : '';
  }

  const subject = t('COMMON:mailto.subject');
  const body = t('COMMON:mailto.template', {
    lnr,
    additionalLnr,
    fio,
    phone,
    appeal,
  });

  return {
    href: PULSE_SUPPORT_EMAIL,
    mailtoHref: getSupportMailHref({
      email: PULSE_SUPPORT_EMAIL,
      subject,
      body,
    }),
    subject,
    phone,
    fio,
    lnr,
    additionalLnr,
    appeal,
  };
};
